import GiggWatermark from './GiggWatermark';

export default GiggWatermark;
